import axios from 'axios';
import { BASE_URL } from './config';

export function sendFeedback(data) {
  return axios.post(`${BASE_URL}/feedback`, data, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
}
